<template>
        <card>
                <template slot="header">
                    <h3 class="card-title">Notification Config</h3>
                </template>
                <nav class="row">
                    <ol class="breadcrumb arr-right bg-breadcrum">
                       <li class="breadcrumb-item">
                          <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                       </li>
                         <li class="breadcrumb-item">
                            <router-link to="settings"></i>&nbsp;Change Password </router-link>
                         </li>
                         <li class="breadcrumb-item">
                            <router-link to="creditconfig"></i>&nbsp;Leave Credit Config </router-link>
                        </li>
                         <li class="breadcrumb-item active">Notification Config</li>
                    </ol>
                 </nav>
                 <hr style="margin-top:-10px"/>
                 <form @submit="formSubmit">
                    <div class="row">
                       <div class="col-md-12">
                          <div class="row">
                             <div class="col-md-4">
                                <div class="form-group"> 
                                   <p class="p-text"> Email Address :</p>
                                   <input type="email" v-model="email" class="form-control" autocomplete="off">
                                     <!-- <span v-if="error_handler.current_password" class="invalid-feedback">{{ error_handler.current_password[0] }}</span> -->
                                </div>
                                <div class="form-group"> 
                                    <p class="p-text"> Password :</p>
                                    <input type="password" v-model="password" class="form-control" autocomplete="off">
                                      <!-- <span v-if="error_handler.current_password" class="invalid-feedback">{{ error_handler.current_password[0] }}</span> -->
                                 </div>
                             </div>
                          </div>
                          <br/>
                          <button class="btn btn-info"><i class="fa fa-save"></i>&nbsp;Save Changes</button> 
                          <br/> <br/>
                       </div>
                    </div>
                 </form>
        </card>		
    </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    
    export default {
        components: {
            Card
        },
        data(){
            return{
                email:'',
                password:'',
            }
            },
        created:function () {
        
        },    
        methods:{
            
            formSubmit(e){
                e.preventDefault()
            }
        }
    }
    </script>
    <style>
         .bg-breadcrum{
            background:#fff;
         }
         .p-text{
             color:#666;
         }
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-settings/todo-notification-config.vue